import clsx from "clsx";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

export const MenuLink = ({ routeDestination, children, classNames, handleClick }) => {
    return (
        <a href={routeDestination} onClick={handleClick}>
            <p className={clsx(
                "font-normal relative z-30 phone:text-[14px] text-[16px] tracking-text phone:leading-[23.8px] leading-[27.2px]",
                "hover:cursor-pointer text-neutral-50",
                classNames
            )}>{children}</p>
        </a>
    );
};

MenuLink.propTypes = {
    routeDestination: PropTypes.string,
    classNames: PropTypes.string
};